import React from 'react';
import { Star, ShieldCheck, Globe } from 'lucide-react';
import { Button } from './ui/Button';
import { HERO_IMAGE } from '../utils/heroImage';
export function Hero() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden bg-stadium-glow" data-id="element-79" data-mp="9ktefowaq4ya">
      <div className="container mx-auto px-4 relative z-10" data-id="element-80" data-mp="4lqkp0lrnl5m">
        <div className="max-w-5xl mx-auto text-center" data-id="element-81" data-mp="4n9wof0e3a1l">
          <div data-id="element-82" data-mp="12a0l5b5wm0um">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-navy-800/80 border border-gold-500/30 text-gold-400 font-oswald uppercase tracking-widest text-sm mb-6 backdrop-blur-sm" data-id="element-83" data-mp="128fsjr35grze">
              <span className="w-2 h-2 rounded-full bg-gold-500 animate-pulse" data-id="element-84" data-mp="s9zwrat6gujk"></span>
              PROVEN COACHING SYSTEM
            </div>

            <h1 className="font-anton text-5xl md:text-7xl lg:text-8xl text-white uppercase tracking-wide leading-[1.1] mb-6 drop-shadow-2xl" data-id="element-85" data-mp="nekqp51ew2xp">
              Stop Planning For Hours. Build Your Entire Football Season In{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-600" data-id="element-86" data-mp="3j7zgtn69y0is">
                Under 5 Minutes
              </span>
            </h1>

            <p className="text-lg md:text-2xl text-gray-300 max-w-3xl mx-auto mb-10 font-medium leading-relaxed" data-id="element-87" data-mp="39acy0plutotj">
              Save time, reduce stress, and develop better players — without
              spending hours planning training sessions from scratch.
            </p>
          </div>

          <div className="relative mb-12 group" data-id="element-88" data-mp="30g6jxho33v5s">
            <div className="absolute -inset-4 bg-gradient-to-r from-gold-500/20 via-green-500/20 to-gold-500/20 rounded-2xl blur-2xl opacity-50 group-hover:opacity-70 transition-opacity duration-500" data-id="element-89" data-mp="359syxghq0b4r"></div>
            <img src={HERO_IMAGE} alt="Football Ready System 365 - 6 Volumes + 5 Bonuses" width={1536} height={1024} loading="eager" fetchPriority="high" decoding="sync" style={{
            aspectRatio: '1536 / 1024'
          }} className="relative block w-full h-auto rounded-xl shadow-2xl border border-navy-700/50" data-id="element-90" data-mp="2vjpy4u4cxsvv" />
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-91" data-mp="ibgjana5x7gj">
            <Button size="xl" onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-92" data-mp="dd5cymj2tf32">
              YES, I WANT MY SYSTEM NOW
            </Button>

            <div className="flex flex-col items-center gap-3" data-id="element-93" data-mp="15zzv3csf82dd">
              <div className="flex items-center gap-1" data-id="element-94" data-mp="111eqz2a1syjn">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-95" data-mp="x0l3ga0iplra" data-mpi={i} />)}
                <span className="ml-2 font-oswald text-lg text-gray-200" data-id="element-96" data-mp="3hqu2ybi9aa1p">
                  4.9/5 — Verified Reviews&nbsp; | &nbsp;Trusted by 3,000+
                  Football Coaches Worldwide
                </span>
              </div>

              <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-97" data-mp="21bfulng27bte">
                <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-98" data-mp="2697m4gcskvx2" />
                <span data-id="element-99" data-mp="2b1966og7bqxn">7-Day Money Back Guarantee — Zero Risk</span>
              </div>

              <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-100" data-mp="2fzsqkkf5cunw">
                <Globe className="w-4 h-4 text-gold-500" data-id="element-101" data-mp="2kyvntiovxwlb" />
                <span data-id="element-102" data-mp="2kxc6rpvenhih">Pay In Your Local Currency</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}